"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_bootstrap_1 = require("react-bootstrap");
const LandingStore_1 = require("../LandingStore");
class SuccessPopup extends React.Component {
    render() {
        return React.createElement("div", null, React.createElement(react_bootstrap_1.Modal, { show: true, onHide: () => {} }, React.createElement(react_bootstrap_1.Modal.Header, { closeButton: true }, React.createElement(react_bootstrap_1.Modal.Title, null, "Confirmation")), React.createElement(react_bootstrap_1.Modal.Body, null, React.createElement("h4", null, " Confirmation link sent to your e-mail. "), React.createElement("h4", null, " Please activate it.")), React.createElement(react_bootstrap_1.Modal.Footer, null, React.createElement(react_bootstrap_1.Button, { onClick: () => {
                this.props.openModal(LandingStore_1.LandingModal.Closed);
            } }, "Close"))));
    }
}
exports.default = SuccessPopup;
;


//////////////////
// WEBPACK FOOTER
// ./client/src/landing/components/SuccessPopup.tsx
// module id = 1063
// module chunks = 0 1